import styles from './PortalPlaceholder.module.css';

const PortalAnalyticsPage: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
        </svg>
      </div>
      <h1 className={styles.title}>Analytics</h1>
      <p className={styles.subtitle}>Coming Soon</p>
      <p className={styles.description}>
        This page will provide detailed analytics and insights about your order management performance, response times, conversion rates, and more.
      </p>
    </div>
  );
};

export default PortalAnalyticsPage;
